import { render, staticRenderFns } from "./ViewerAccess.vue?vue&type=template&id=63b08f6c&scoped=true&"
import script from "./ViewerAccess.vue?vue&type=script&lang=js&"
export * from "./ViewerAccess.vue?vue&type=script&lang=js&"
import style0 from "./ViewerAccess.vue?vue&type=style&index=0&id=63b08f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b08f6c",
  null
  
)

export default component.exports